<div class="dialog-title">{{editNew}} {{type}}</div>
<form [formGroup]="itemDialogForm">
  <mat-form-field *ngIf="type != 'Race'">
    <input matInput formControlName="name" required placeholder="Name" />
    <mat-error>{{type}} name is required.</mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="type == 'Race'">
    <input matInput formControlName="name" required placeholder="Race" />
    <mat-error>{{type}} is required.</mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="type == 'Property Type'">
    <mat-label>Purpose</mat-label>
    <mat-select required formControlName="commercial">
      <mat-option *ngFor="let masterCom of commercialEnum | keyvalue" [value]="masterCom.key">
        {{ masterCom.value }}</mat-option>
    </mat-select>
    <mat-error>Property Type purpose is required.</mat-error>
  </mat-form-field>


  <div class="dialog-buttons">
    <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
    <button mat-button color="primary" (click)="save()">Confirm</button>
  </div>
</form>